<section class="page-content">
  <p class="status">Missing Permission</p>
  <p class="description">
    <ng-container *ngIf="errorMessage$ | async as errorMessage else generalError">
      {{errorMessage}}
    </ng-container>
    <ng-template #generalError>
      You don't have a suitable permission to access this page.
      <br>
      Please contact your administrator.
    </ng-template>
  </p>
  <button mat-flat-button class="home-button" color="primary" [routerLink]="buttonUrl">Back to Home Page</button>
</section>
